import { render, staticRenderFns } from "./VueAliplayer.vue?vue&type=template&id=005ebc14&"
import script from "./VueAliplayer.vue?vue&type=script&lang=js&"
export * from "./VueAliplayer.vue?vue&type=script&lang=js&"
import style0 from "./VueAliplayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports